import $ from 'jquery';

export const elements = {
    call: '.js-Radio-Call',
    holder: '.js-RegisterContactSwitcher-Holder',
};

export const onClick = function () {
    const $this = $(this);
    const $inputHolder = $this.parents(elements.holder);
    const $fieldset = $this.parent('fieldset').next('fieldset');
    const $fieldsets = $inputHolder.find('fieldset');

    if ($fieldsets.find('input[type="phone"], input[type="email"]').length) {
        $fieldsets.not('.js-Radio-Holder').addClass('fn-hidden');
        $fieldset.removeClass('fn-hidden');
    }
};

export default {
    init(params) {
        params.$document.on('click', `${elements.holder} ${elements.call}`, onClick);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/register-switch.js